<template>
  <div class="mx-5">
    <prismic-rich-text
      :field="title"
      class="page-title d-flex w-100 mb-3"
      :class="textClasses"
      :style="{ color }"
    ></prismic-rich-text>
    <prismic-rich-text
      :field="subtitle"
      class="page-subtitle d-flex w-100"
      :class="textClasses"
      :style="{ color }"
    ></prismic-rich-text>
  </div>
</template>

<script>
export default {
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      title: '',
      subtitle: '',
      alignText: '',
      color: '#000'
    };
  },
  computed: {
    textClasses() {
      return this.alignText === 'left'
        ? 'justify-content-start'
        : this.alignText === 'right'
        ? 'justify-content-end'
        : 'justify-content-center';
    }
  },
  created() {
    const { primary } = this.slice;
    this.title = primary.title1;
    this.subtitle = primary.subtitle[0]?.text ? primary.subtitle : '';
    this.alignText = primary.align_text ? primary.align_text : 'center';
    this.color = this.slice?.primary?.font_color;
  }
};
</script>

<style lang="scss" scoped>
.page-title {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    text-align: center;
    margin: 0;
  }
}
.page-subtitle {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    text-align: center;
    margin: 0;
  }
}
</style>
